if (!customElements.get('onehalf-menu')) {
  customElements.define(
    'onehalf-menu',
    class OnehalfMenu extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.oh-menu__trigger');
        this.dialog = this.querySelector('.oh-menu__dialog');
        if (!this.trigger || !this.dialog) return;

        this.links = Array.from(this.dialog.querySelectorAll('[data-oh-menu-media]'));
        this.media = Array.from(this.dialog.querySelectorAll('[data-oh-menu-media-item]'));
        this.closeButton = this.dialog.querySelector('[data-oh-menu-close]');
        this.linksHalf = this.dialog.querySelector('.oh-menu__half--links');
        this.finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.closing = false;

        const preload = () => {
          this.dialog.querySelectorAll('img[loading="lazy"]').forEach((img) => {
            img.loading = 'eager';
          });
        };
        ['pointerenter', 'pointerdown', 'focus'].forEach((type) => {
          this.trigger.addEventListener(type, preload, { once: true, passive: true });
        });

        this.trigger.addEventListener('click', () => {
          preload();
          this.open();
        });
        this.dialog.querySelectorAll('[data-oh-menu-close]').forEach((button) => {
          button.addEventListener('click', () => this.close());
        });

        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        });

        this.links.forEach((link) => {
          link.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'mouse' && this.finePointer.matches) this.activate(link);
          });
          link.addEventListener('focus', () => {
            if (link.matches(':focus-visible')) this.activate(link);
          });
        });

        this.dialog.querySelector('.oh-menu__list')?.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'mouse') this.activate(null);
        });
      }

      open() {
        if (this.dialog.open) return;
        clearTimeout(this.closeTimer);
        this.closing = false;
        this.activate(null);

        this.dialog.showModal();
        this.dialog.scrollTop = 0;
        if (this.linksHalf) this.linksHalf.scrollTop = 0;
        this.closeButton?.focus({ preventScroll: true });

        document.documentElement.classList.add('oh-menu-open');
        this.trigger.setAttribute('aria-expanded', 'true');

        this.dialog.getBoundingClientRect();
        this.dialog.classList.add('is-open');
      }

      close() {
        if (!this.dialog.open || this.closing) return;
        this.closing = true;
        this.dialog.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');

        this.closeTimer = window.setTimeout(
          () => {
            this.dialog.close();
            document.documentElement.classList.remove('oh-menu-open');
            this.closing = false;
            this.trigger.focus({ preventScroll: true });
          },
          this.reducedMotion.matches ? 200 : 650
        );
      }

      activate(link) {
        this.links.forEach((item) => item.classList.toggle('is-active', item === link));
        const index = link ? link.dataset.ohMenuMedia : '1';
        this.media.forEach((item) => item.classList.toggle('is-active', item.dataset.ohMenuMediaItem === index));
      }
    }
  );
}
